import React from 'react'

import EntryCard from '../../../react4xp/components/EntryCard'

function EntryCardPart({ title, intro, image, imageMobile, position, cta }) {
  return (
    <EntryCard
      imagePosition={position}
      src={image?.link}
      srcMobile={imageMobile?.link}
      alt={image?.alt}
      title={title}
      text={intro}
      hrefText={cta?.text}
      href={cta?.url?.href}
      external={cta?.isExternal}
    />
  )
}

export default (props) => <EntryCardPart {...props} />
